import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/errors";
import { GoogleG } from "../../components/GoogleG";

export default function Register() {
  const { user, loading, register, loginWithGoogle } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="py-24 text-center text-stone-500">Loading…</div>;
  if (user) return <Navigate to="/account" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await register(email.trim(), password, name.trim());
      window.location.href = u.is_admin ? "/admin" : "/account";
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-[70vh]">
      <div className="blob blob-gold" style={{ width: 500, height: 500, top: 40, right: -180 }}/>
      <div className="blob blob-terra" style={{ width: 400, height: 400, bottom: 100, left: -140 }}/>
      <div className="max-w-md mx-auto px-6 py-16 relative">
        <div className="text-center mb-8">
          <div className="uppercase tracking-[0.3em] text-xs text-[#8B7355] mb-3">Join DailyBeans</div>
          <h1 className="font-serif-display text-5xl text-[#3B2F2F]">Create your account</h1>
          <p className="text-sm text-stone-500 mt-2">Get 10% off with code <span className="font-semibold text-[#3B2F2F]">WELCOME10</span> on your first order.</p>
        </div>

        <form onSubmit={submit} className="bg-white/80 backdrop-blur rounded-3xl border border-stone-200 shadow-xl p-8 space-y-4" data-testid="register-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-stone-500">Name</label>
            <input value={name} onChange={(e)=>setName(e.target.value)} data-testid="register-name"
                   className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-stone-500">Email</label>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="register-email"
                   className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-stone-500">Password (min 6 chars)</label>
            <input type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="register-password"
                   className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
          </div>
          {err && <div data-testid="register-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{err}</div>}
          <button type="submit" disabled={busy} data-testid="register-submit"
                  className="w-full bg-[#3B2F2F] text-[#FDFBF7] rounded-full py-3 font-semibold hover:bg-black disabled:opacity-60">
            {busy ? "Creating account…" : "Create account"}
          </button>
          <div className="text-center text-xs">
            <Link to="/login" data-testid="link-login" className="text-[#8B7355] hover:text-[#3B2F2F]">Already have an account? Sign in →</Link>
          </div>

          <div className="relative py-2 flex items-center gap-3 text-xs text-stone-400">
            <div className="flex-1 border-t border-stone-200"/> or <div className="flex-1 border-t border-stone-200"/>
          </div>

          <button type="button" onClick={loginWithGoogle} data-testid="register-google"
                  className="w-full border border-stone-300 rounded-full py-3 text-sm font-medium hover:bg-stone-50 flex items-center justify-center gap-2">
            <GoogleG/> Continue with Google
          </button>
        </form>
      </div>
    </div>
  );
}
